var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-container',{staticClass:"pr-h-screen"},[_c('el-aside',{attrs:{"width":"60px"}},[(_vm.$store.getters.roles)?_c('Navigation'):_vm._e()],1),_c('el-container',{staticClass:"pr-p-0"},[_c('el-main',{staticClass:"pr-p-0 pr-flex pr-flex-col"},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }